import React, { useState, createContext, useContext } from "react";
import Toasts from "../../../components/toast";

const Context = createContext();

export const ErrorContext = () => useContext(Context);
export const ErrorProvider = ({ children }) => {
  const [showToast, setShowToast] = useState(false);
  const [opciones, setOpciones] = useState([]);

  return (
    <>
      <Context.Provider
        value={{ showToast, opciones, setShowToast, setOpciones }}
      >
        {children}
      </Context.Provider>
      {showToast ? (
        <Toasts
          type={opciones.type}
          message={opciones.message}
          active={opciones.active}
        ></Toasts>
      ) : (
        ""
      )}
    </>
  );
};
